//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchInput from "./../common/search_input.vue";
export default {
  data() {
    return {
      list_ary: [],
      left_ary: ["今天", "昨天", "最近三天", "本周"],
      placeholder: "请输入标题关键字",
      loading: false,
      toast_error: false,
      toast_error_text: "",
      toast_success: false,
      toast_success_text: "",

      form_up: {
        title: "",
        content: "",
        dialog: false
      },
      toast: {
        dialog: false,
        text: ""
      }
    };
  },
  mounted() {
    if (!localStorage.getItem("wkt_login_peo")) {
      this.toast_value = "请登录";
      this.show_toast = true;
      let timer = setTimeout(() => {
        this.$router.push({
          path: "/my"
        });
      }, 800);
    }
    this.search();
  },
  components: {
    SearchInput: SearchInput
  },
  methods: {
    search: function() {
      this.loading = true;
      let formData = new FormData();
      formData.append("action_type", "get_faq");
      formData.append("orderByObj", "id");
      formData.append("orderBy", "desc");
      this.loading = true;
      this.$http({
        url: "/search/common.php",
        method: "post",
        data: formData
      }).then(res => {
       this.loading = false;
          this.list_ary = res.data.data;
      });

    },
    showMsgFromChild: function(key) {
      this.loading = true;
      this.$http
        .get("/search/search.php", {
          //根据输入进行查询
          params: {
            form: "stu_to_question",
            key: key,
            orderByObj: "id",
            orderBy: "desc"
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data == "") {
            this.toast_error_text = "搜索内容不存在";
            this.toast_error = true;
          } else {
            this.list_ary = res.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showMsgFromChildLeft: function(time) {
      this.loading = true;
      this.$http
        .get("/search/search_left.php", {
          //根据年代进行查询
          params: {
            form: "stu_to_question",
            time: time
          }
        })
        .then(res => {
          console.log(res);
          this.loading = false;
          if (res.data == "") {
            this.toast_error_text = "该时段暂无问题";
            this.toast_error = true;
          } else {
            this.list_ary = res.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    enter_detail: function(item) {
      this.$router.push({
        path: "/stu_to_answer",
        query: {
          id: item.id,
          name: item.name,
          title: item.title,
          ctn: item.ctn,
          time: item.time,
          state: item.state
        }
      });
    },
    onSubmit() {
      //提交数据

      if (this.form_up.title == "" || this.form_up.content == "") {
        this.toast.text = "信息不完整";
        this.toast.dialog = true;
        return;
      }

      this.$http
        .get("/upload/stu_upload.php", {
          params: {
            operate_type: "up_question",
            name: JSON.parse(localStorage.getItem("login_peo")).stu_name,
            title: this.form_up.title,
            ctn: this.form_up.content
          }
        })
        .then(res => {
          if (res.data.status == 1) {
            this.search();
            this.form_up.title = "";
            this.form_up.content = "";
          }
          this.toast.text = res.data.info;
          this.toast.dialog = true;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/online_answer/stu_up_question.vue